import React from 'react'
import ErroredBlockView from './Error'

const UnknownBlockView = () => <ErroredBlockView title="Unknown block type" />

export default UnknownBlockView
